import { t } from '@hefe/i18n';
import { KnowledgeBaseCategory } from '@hefe/models';
import { KnowledgeBaseApi } from '@hefe/store';
import { Space, TreeDataNode, TreeSelect, Typography } from 'antd';
import { useMemo } from 'react';

interface SwitchArticlesPopconfirmComponentProps {
  onSelect: (value: string) => void;
}

export default function SwitchArticlesPopconfirmComponent(
  props: SwitchArticlesPopconfirmComponentProps
) {
  const { data: navigation = [], isFetching: isFetchingNavigation } =
    KnowledgeBaseApi.useFetchNavigationQuery();

  const categoryTreeData = useMemo(() => {
    const navigationNode = (category: KnowledgeBaseCategory): TreeDataNode => {
      return {
        title: category.name,
        value: category.id,
        children: category?.children?.map((child) => navigationNode(child)),
        key: category.id,
      } as TreeDataNode;
    };

    const returnData = navigation.map((category) => navigationNode(category));

    return [
      ...returnData,
      {
        title: t('knowledge_base.categories.uncategorized'),
        value: 0,
      },
    ];
  }, [navigation]);

  return (
    <Space direction="vertical">
      <Typography.Text>
        {t('knowledge_base.articles.switch_category.description')}
      </Typography.Text>
      <TreeSelect
        allowClear
        showSearch
        style={{ width: '100%' }}
        placeholder={t(
          'knowledge_base.articles.switch_category.select_category'
        )}
        treeDefaultExpandAll
        treeData={categoryTreeData}
        loading={isFetchingNavigation}
        onChange={(value) => props.onSelect(value)}
      />
    </Space>
  );
}
